<template>
  <TabelaPadrao
    templateColumns="50px 150px 1fr"
    acao="65px"
    :conteudoPaginado="conteudo"
    :conteudoTotal="conteudo"
    :estruturaTabela="estruturaTabela"
    :deleteTabela="deletaItem"
    alertaVermelho="Identificamos que o produto não se encontra mais vigente ou foi alterado, entretanto localizamos uma ou mais NCMs correlacionadas vigentes que podem substituir. <br>Clique aqui para selecionar uma nova NCM."
    caminhoAlertaVermelho="vigente"
    :alertaVermelhoClick="alertaVermelhoClick"
  />
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";

export default {
  name: "TabelaHome",
  components: {
    TabelaPadrao
  },
  props: {
    conteudo: Array,
    deletaItem: Function,
    selecionaNcm: Function
  },
  data() {
    return {
      estruturaTabela: [
        { nome: "Nº", valor: "numeracao", alinhamento: "centro" },
        { nome: "NCM", valor: "ncm", alinhamento: "centro", destacado: true },
        { nome: "DESCRIÇÃO", valor: "descricao" }
      ]
    };
  },
  methods: {
    async alertaVermelhoClick(item) {
      await this.deletaItem(item);
      await this.selecionaNcm(item, false);
    }
  }
};
</script>

<style lang="scss" scoped></style>
